import { render, staticRenderFns } from "./DrawerJsonLdTemplate.vue?vue&type=template&id=63bb683e&scoped=true&"
import script from "./DrawerJsonLdTemplate.vue?vue&type=script&lang=js&"
export * from "./DrawerJsonLdTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DrawerJsonLdTemplate.vue?vue&type=style&index=0&id=63bb683e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bb683e",
  null
  
)

export default component.exports